import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ChronometerIcon from '../../../../assets/icons/ChronoMeter.svg';
import QuestionMarkIcon from '../../../../assets/icons/QuestionMark.svg';
import AuthContext from '../../../../auth/AuthContext';
import ConfirmDialogBox from '../../../confirmDialog/ConfirmDialogBox';
import SharedService from '../../../../services/SharedService';

const QuizCard = ({ no, data }) => {
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    const [showDialog, setShowDialog] = useState(false);
    const [selectedQuiz, setSelectedQuiz] = useState(null);

    const minutesToTime = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    };

    const onConfirmStartHandler = (data) => {
        setSelectedQuiz(data);
        setShowDialog(true);
    };

    const onStartHandler = (data) => {
        authContext.setOnGoingValidations(true);
        navigate(`/quizzes/${SharedService.GenerateSlug(data.quizName)}/start`, { state: { id: data.id } });
    };

    return (
        <>
            <div
                className="card border-0 shadow p-3 p-md-4 h-100"
                style={{ minHeight: "100px" }}
            >
                <div className="text-center fw-bold w-100 mb-2">Quiz {no + 1}</div>
                <div className="text-center fw-light w-100 mb-3" style={{ minHeight: "48px" }}>
                    {data.quizName}
                </div>

                <div className="progress" style={{ height: "6px" }}>
                    <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: `${data.mcqScore}%` }}
                        aria-valuenow={data.mcqScore}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>

                <div className="d-flex justify-content-left mb-3">
                    <div className="fw-light">
                        {data.correctMCQAnswers}/{data.totalMCQQuestions}
                    </div>
                </div>

                <div className="d-flex justify-content-between mb-4">
                    <div className="fw-light" title="No of Questions">
                        <img
                            src={QuestionMarkIcon}
                            alt="Questions"
                            className="hover:opacity-70 me-2 mb-1"
                        />
                        {data.totalMCQQuestions}
                    </div>
                    <div className="fw-light" title="Duration">
                        <img
                            src={ChronometerIcon}
                            alt="Duration"
                            className=" hover:opacity-70 me-2 mb-1"
                        />
                        {minutesToTime(data.quizTimeInMinutes)}
                    </div>
                </div>

                <div className="d-flex justify-content-center mb-1">
                    {data.isCompleted ? (
                        <button

                            className="px-5 py-2 rounded-pill btn w-100 btn-outline-success"
                            onClick={() => navigate(`/quizzes/${SharedService.GenerateSlug(data.quizName)}/review`, { state: { id: data.id } })}
                        >
                            Review
                        </button>
                    ) : (
                        <button
                            className="px-5 py-2 rounded-pill btn w-100 btn-outline"
                            onClick={() => onConfirmStartHandler(data)}
                        >
                            Start
                        </button>
                    )}
                </div>
            </div>
            {/* Confirmation Dialog */}
            <ConfirmDialogBox
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    onStartHandler(selectedQuiz);
                }}
                title={
                    <>
                        Are you sure you want to start <strong>{selectedQuiz?.quizName}</strong>?<br />
                        <small className="text-muted">
                            Once the quiz is started, you cannot stop or re-attend it.
                        </small>
                    </>
                }
                confirmLabel="Start Quiz"
                cancelLabel="Cancel"
            />
        </>
    );
};

export default QuizCard;
